export default "__VITE_ASSET__e58fb945__"